export const GALLERY_IMAGE_COVER_RANGE = 0.12;

export const getGalleryImageAspectRatio = (
  width?: number,
  height?: number
): number | undefined => {
  if (!width || !height || height <= 0) {
    return undefined;
  }

  return width / height;
};

export const getGalleryImageFitFromAspectRatio = ({
  imageRatio,
  canvasRatio,
  coverRange = GALLERY_IMAGE_COVER_RANGE,
}: {
  imageRatio?: number;
  canvasRatio?: number;
  coverRange?: number;
}): 'cover' | 'contain' => {
  if (
    typeof imageRatio !== 'number' ||
    imageRatio <= 0 ||
    typeof canvasRatio !== 'number' ||
    canvasRatio <= 0 ||
    coverRange < 0
  ) {
    return 'contain';
  }

  return Math.abs(imageRatio - canvasRatio) <= coverRange ? 'cover' : 'contain';
};
